module.exports = __webpack_public_path__ + "img/gallery-08.23d1438d.jpg";